import React from 'react'
import { withStyles } from '@material-ui/core'

import ShowStaticPage from 'staticPages/Show'

const Show = ({ ...props }) => {
  return <ShowStaticPage slug={props.guideSlug} />
}

const styles = theme => ({
  root: {
    width: '100%',
    minHeight: 'calc(100vh - 128px)',
    margin: theme.spacing(-2, 0, -6),
    background: theme.palette.background.default,
  },
})

export default withStyles(styles)(Show)
